import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import {connect} from 'react-redux';
import {getOS} from '../lib/libraries/helper_functions';
import axios from 'axios';
import myStyle from '../components/code-sender/codeSender.css';
import modalStyle from '../components/code-sender/modalStyle.css';
import xBox from '../../static/btn-close.png';
import uploadIcon from '../components/code-sender/upload-icon.png';
// import socketio from 'socket.io-client';
// import Daemon from 'arduino-create-agent-js-client';
// const daemon = new Daemon('http://127.0.0.1:8991/Intel:arc32:arduino_101/compute');
// const baseUrl = 'http://localhost:3005';
const baseUrl = 'https://api.xcoding.co.kr';

// import {changeMonskitModuleList} from '../reducers/inserted_list';

const localUrl = 'http://localhost:35548';
// const localUrl = 'http://192.168.0.52:35548';


import {FormattedMessage, injectIntl} from 'react-intl';
import defaultsDeep from 'lodash.defaultsdeep';
import {changeMonskitGeneratedCodes} from '../reducers/generated-codes';
import {setServoLiveConnected} from '../reducers/servo-live';

import {
    connectServoLive,
    disconnectServoLive
} from '../lib/servo-live-transport'

const socket = new WebSocket('ws://localhost:8989/ws');
socket.onopen = function (e) {
};

const getUploadStrings = locale => {
    const isKorean = locale === 'ko';
    return {
        buttonLabel: isKorean ? '업로드' : 'Upload',
        uploadToXrobo: isKorean ? 'xrobo로 전송하기' : 'Send to xrobo',
        serialPortSelection: isKorean ? '시리얼포트 선택' : 'Select Serial Port',
        serverSending: isKorean ? '서버로 전송 중\n' : 'Sending to server\n',
        fileReceived: isKorean ? '파일 준비 완료\n' : 'File ready\n',
        selectSerialForUpload: isKorean ?
            '포트를 선택해 주세요\n' :
            'Choose a serial port\n',
        uploadDone: isKorean ? '업로드 완료\n' : 'Upload complete\n',
        compileError: isKorean ?
            '컴파일 에러\n코드를 다시 확인해 주세요.\n' :
            'Compile error\nCheck the code and try again.\n',
        serverError: isKorean ? '서버 오류\n잠시 후 다시 시도해 주세요.\n' : 'Server error\nPlease try again shortly.\n',
        compilerBusy: isKorean ?
            '업로드 요청이 많아 대기열이 가득 찼습니다.\n잠시 후 다시 시도해 주세요.\n' :
            'The upload queue is full.\nPlease try again shortly.\n',
        compileQueueTimedOut: isKorean ?
            '업로드 요청이 많아 대기 시간이 초과됐습니다.\n잠시 후 다시 시도해 주세요.\n' :
            'The upload queue wait timed out.\nPlease try again shortly.\n',
        compileTimedOut: isKorean ?
            '코드 컴파일 시간이 초과됐습니다.\n잠시 후 다시 시도해 주세요.\n' :
            'Code compilation timed out.\nPlease try again shortly.\n',
        noPortsFound: isKorean ?
            '연결된 포트를 찾지 못했습니다.\n기기를 다시 연결한 뒤 다시 시도해 주세요.\n' :
            'No connected ports were found.\nReconnect the device and try again.\n',
        portListError: isKorean ?
            '포트 목록을 불러오지 못했습니다.\n브라우저 또는 연결 상태를 확인해 주세요.\n' :
            'Could not load the port list.\nCheck the browser or device connection.\n',
        networkError: isKorean ?
            '서버에 연결하지 못했습니다.\n인터넷 연결 상태를 확인한 뒤 다시 시도해 주세요.\n' :
            'Could not reach the server.\nCheck the internet connection and try again.\n',
        requestTimedOut: isKorean ?
            '서버 응답이 지연되고 있습니다.\n잠시 후 다시 시도해 주세요.\n' :
            'The server response took too long.\nPlease try again shortly.\n',
        filePrepareError: isKorean ?
            '업로드 파일을 준비하지 못했습니다.\n잠시 후 다시 시도해 주세요.\n' :
            'Could not prepare the upload file.\nPlease try again shortly.\n',
        uploading: isKorean ? '업로드 중\n' : 'Uploading\n',
        uploadError: isKorean ?
            '업로드 실패\n포트 선택 또는 연결 상태를 확인해 주세요.\n' :
            'Upload failed\nCheck the selected port or device connection.\n',
        unsupportedBrowser: isKorean ?
            '이 브라우저에서는 업로드를 지원하지 않습니다.\n크롬 또는 엣지 최신 버전에서 다시 시도해 주세요.\n' :
            'This browser does not support uploading.\nTry again in the latest Chrome or Edge.\n',
        permissionDenied: isKorean ?
            '포트 접근이 허용되지 않았습니다.\n브라우저의 포트 선택 창에서 장치를 다시 선택해 주세요.\n' :
            'Port access was not allowed.\nSelect the device again in the browser port picker.\n',
        portBusy: isKorean ?
            '포트를 사용할 수 없습니다.\n다른 프로그램이나 라이브 서보 연결이 포트를 사용 중인지 확인해 주세요.\n' :
            'The port is unavailable.\nCheck whether another program or Live Servo is using the port.\n',
        boardNotResponding: isKorean ?
            '기기가 업로드에 응답하지 않았습니다.\n보드 연결을 확인한 뒤 다시 시도해 주세요.\n' :
            'The device did not respond to the upload.\nCheck the board connection and try again.\n',
        uploadCancelled: isKorean ?
            '포트 선택이 취소되었습니다.\n포트를 다시 선택해 주세요.\n' :
            'Port selection was cancelled.\nChoose the port again.\n',
        errorDetailPrefix: isKorean ? '상세: ' : 'Detail: ',
        disableServoLiveBeforeUpload: isKorean ?
            '업로드 라이브 서보를 꺼주세요.\n' :
            'Turn off Live Servo before uploading.\n',
        portNotSelected: isKorean ?
            '포트를 선택하지 않았습니다\n' :
            'No port selected\n',
        portsFound: count => (isKorean ?
            `포트 ${count}개를 찾았습니다` :
            `${count} port(s) found`),
        selectedPortCompiling: port => (isKorean ?
            `선택 포트: ${port}\n컴파일 중` :
            `Port: ${port}\nCompiling`),
        uploadCompletedInline: isKorean ? '\n업로드가 완료되었습니다.' : '\nUpload completed.',
        selectedPortUploadSoon: port => (isKorean ?
            `\n선택 포트: ${port}\n업로드를 시작합니다.` :
            `\nSelected port: ${port}\nStarting upload.`),
        unknownManufacturer: isKorean ? '알 수 없는 제조사' : 'Unknown Manufacturer'
    };
};

const splitProgressLines = message => (
    String(message || '')
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean)
);

const getUploadErrorDetail = error => {
    if (!error) return '';
    if (typeof error === 'string') return error.trim();
    return String(error.message || error.code || '').trim();
};

const getWebUploadErrorMessage = (error, strings) => {
    const detail = getUploadErrorDetail(error);
    const normalized = detail.toLowerCase();
    let message = strings.uploadError;
    let includeDetail = true;

    if (error?.code === 8 || normalized.includes('no port selected')) {
        message = strings.portNotSelected;
        includeDetail = false;
    } else if (
        normalized.includes('not available in this browser') ||
        normalized.includes('web serial api')
    ) {
        message = strings.unsupportedBrowser;
    } else if (
        normalized.includes('notfounderror') ||
        normalized.includes('the request was cancelled') ||
        normalized.includes('user cancelled')
    ) {
        message = strings.uploadCancelled;
        includeDetail = false;
    } else if (
        normalized.includes('notallowederror') ||
        normalized.includes('securityerror') ||
        normalized.includes('access denied') ||
        normalized.includes('permission')
    ) {
        message = strings.permissionDenied;
    } else if (
        normalized.includes('resource busy') ||
        normalized.includes('device or resource busy') ||
        normalized.includes('port is busy') ||
        normalized.includes('failed to open serial port')
    ) {
        message = strings.portBusy;
    } else if (
        error?.code === 'ETIMEDOUT' ||
        normalized.includes('timeout') ||
        normalized.includes('programmer is not responding') ||
        normalized.includes('not in sync') ||
        normalized.includes('failed uploading') ||
        normalized.includes('exit status 1')
    ) {
        message = strings.boardNotResponding;
    }

    if (!detail || !includeDetail) return message;

    const baseLines = splitProgressLines(message);
    if (baseLines.some(line => detail.toLowerCase().includes(line.toLowerCase()))) {
        return message;
    }

    return `${message}${strings.errorDetailPrefix}${detail}\n`;
};

const getErrorCardLines = (progressLines, locale) => {
    if (!progressLines.length) return [];
    const lastLine = progressLines[progressLines.length - 1];
    const detailPrefix = locale === 'ko' ? '상세:' : 'Detail:';

    if (lastLine.startsWith(detailPrefix) && progressLines.length > 1) {
        return [progressLines[progressLines.length - 2], lastLine];
    }

    return [lastLine];
};

const appendDetailMessage = (message, detail, strings) => {
    const normalizedDetail = String(detail || '').trim();
    if (!normalizedDetail) return message;
    return `${message}${strings.errorDetailPrefix}${normalizedDetail}\n`;
};

const getCompileErrorMessage = (stderr, strings) => {
    const detail = String(stderr || '').trim();
    return appendDetailMessage(strings.compileError, detail, strings);
};

const getRequestErrorDetail = error => {
    const responseData = error?.response?.data;
    if (typeof responseData === 'string' && responseData.trim()) return responseData.trim();
    if (responseData?.stderr) return String(responseData.stderr).trim();
    if (responseData?.error) return String(responseData.error).trim();
    if (error?.message) return String(error.message).trim();
    return '';
};

const getServerRequestErrorMessage = (error, strings) => {
    const response = error?.response;
    const code = response?.data?.code;
    if (code === 'BUSY' || response?.status === 429) return strings.compilerBusy;
    if (code === 'QUEUE_TIMEOUT') return strings.compileQueueTimedOut;
    if (code === 'COMPILE_TIMEOUT') return strings.compileTimedOut;
    const detail = getRequestErrorDetail(error);
    const normalized = detail.toLowerCase();

    if (error?.code === 'ECONNABORTED' || normalized.includes('timeout')) {
        return appendDetailMessage(strings.requestTimedOut, detail, strings);
    }

    if (
        normalized.includes('network error') ||
        normalized.includes('failed to fetch') ||
        normalized.includes('load failed') ||
        !error?.response
    ) {
        return appendDetailMessage(strings.networkError, detail, strings);
    }

    return appendDetailMessage(strings.serverError, detail, strings);
};

const getPortListErrorMessage = (error, strings) => {
    const detail = getRequestErrorDetail(error);
    const normalized = detail.toLowerCase();

    if (
        normalized.includes('network error') ||
        normalized.includes('failed to fetch') ||
        normalized.includes('load failed') ||
        !error?.response
    ) {
        return appendDetailMessage(strings.portListError, detail, strings);
    }

    return appendDetailMessage(strings.portListError, detail, strings);
};

const getPrepareResponseErrorMessage = (resultData, strings) => {
    if (resultData?.code === 'BUSY') return strings.compilerBusy;
    if (resultData?.code === 'QUEUE_TIMEOUT') return strings.compileQueueTimedOut;
    if (resultData?.code === 'COMPILE_TIMEOUT') return strings.compileTimedOut;
    if (resultData?.type === 'CE') {
        return getCompileErrorMessage(resultData?.stderr, strings);
    }
    if (resultData?.type === 'SE') {
        return appendDetailMessage(strings.filePrepareError, resultData?.stderr || resultData?.error, strings);
    }
    return appendDetailMessage(strings.filePrepareError, resultData?.error, strings);
};

const getLiveWorkspaceCode = () => {
    try {
        if (typeof window === 'undefined' || !window.currentBlocklyWorkspace) return '';
        if (!window.Blockly || !window.Blockly.Arduino || !window.Blockly.Arduino.workspaceToCode) return '';
        return window.Blockly.Arduino.workspaceToCode(window.currentBlocklyWorkspace);
    } catch (error) {
        console.error('Failed to generate live workspace code:', error);
        return '';
    }
};

const getStatusConfig = (locale, phase) => {
    const isKorean = locale === 'ko';
    const map = {
        sending: {
            label: isKorean ? '준비 중' : 'Preparing',
            title: isKorean ? '업로드를 준비하고 있습니다' : 'Preparing the upload',
            description: isKorean ? '코드를 정리하고 서버로 전송하고 있습니다.' : 'Packaging code and sending it to the server.',
            progress: 20
        },
        selectPort: {
            label: isKorean ? '포트 선택' : 'Port Selection',
            title: isKorean ? '업로드할 포트를 선택해 주세요' : 'Choose a serial port',
            description: isKorean ? '연결된 장치를 선택하면 업로드를 진행합니다.' : 'Choose the connected device to continue.',
            progress: 45
        },
        compiling: {
            label: isKorean ? '컴파일 중' : 'Compiling',
            title: isKorean ? '업로드 파일을 만드는 중입니다' : 'Compiling the upload package',
            description: isKorean ? '업로드 가능한 형태로 코드를 변환하고 있습니다.' : 'Building the code into an uploadable file.',
            progress: 62
        },
        uploading: {
            label: isKorean ? '업로드 중' : 'Uploading',
            title: isKorean ? '기기에 코드를 업로드하고 있습니다' : 'Uploading code to the device',
            description: isKorean ? '연결을 유지한 채 잠시만 기다려 주세요.' : 'Keep the device connected while the upload finishes.',
            progress: 84
        },
        complete: {
            label: isKorean ? '완료' : 'Complete',
            title: isKorean ? '업로드가 완료되었습니다' : 'Upload completed',
            description: isKorean ? '이제 기기에서 결과를 확인할 수 있습니다.' : 'You can now check the result on the device.',
            progress: 100
        },
        error: {
            label: isKorean ? '문제 발생' : 'Error',
            title: isKorean ? '업로드를 완료하지 못했습니다' : 'The upload could not be completed',
            description: isKorean ? '아래 내용을 확인한 뒤 다시 시도해 주세요.' : 'Review the details below and try again.',
            progress: 100
        }
    };
    return map[phase] || map.sending;
};

class CodeSender extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
            'codeGenerate',
            'handleSubmit',
            'handleModal',
            'appendProgressText',
            'clearAutoCloseTimer',
            'replaceProgressText',
            'setUploadPhase',
            'setPort',
            'pauseServoLiveIfNeeded',
            'resumeServoLiveIfNeeded'
        ]);
        this.state = {
            generated_code_state: [],
            isOpen: false,
            progressText: '',
            selectable: false,
            serialList: [],
            cmdLine: '',
            key: '',
            uploadProgress: '',
            currentOs: '',
            uploadPhase: 'sending',
            progressLines: [],

            /* for windows mode*/
            isConnected: false,
            selectedPort: undefined,
            portSelectModalOpen: false,
            progressTextAfterSelectPort: '',

            wasServoLiveEnabledBeforeUpload: false,
            servoLiveReconnectPort: null
        };
    }

    componentDidMount() {
        const strings = getUploadStrings(this.props.intl.locale);
        this.setState({
            progressText: strings.serverSending,
            uploadProgress: strings.uploading.trim(),
            uploadPhase: 'sending',
            progressLines: splitProgressLines(strings.serverSending)
        });
        // 연결 상태 업데이트 이벤트 핸들러
        // window.onConnectionStateUpdate = (state) => {
        //     console.log("Connection state updated:", state);
        //     this.setState({connectionStatus: state});
        // };

        // 업로드 진행 상황 업데이트 이벤트 핸들러
        window.uploadFinished = false; // 중복 호출 방지를 위한 플래그

        window.onProgressUpdate = progress => {
            console.log('Upload progress updated:', progress);

            // 진행 상황에 따른 UI 업데이트
            if (progress === 'upload finished' && !window.uploadFinished) {
                window.uploadFinished = true; // 완료 상태로 설정
                const strings = getUploadStrings(this.props.intl.locale);
                this.setUploadPhase('complete');
                this.appendProgressText(strings.fileReceived + strings.uploadDone);
            }
        };

        window.AndroidInterfaceCallback = (arg) => {
            if('Android upload confirm' === arg) {
                this.codeGenerate('Android upload confirm');
            }
        }

        this.setState({
            currentOs: getOS()
        });
        setTimeout(() => {
            console.log(this.state.currentOs);
        }, 2000)

    }
    setUploadPhase(phase) {
        this.setState({uploadPhase: phase}, () => {
            this.clearAutoCloseTimer();
        });
    }
    componentWillUnmount() {
        this.clearAutoCloseTimer();
    }
    clearAutoCloseTimer() {
        if (this.autoCloseTimer) {
            clearTimeout(this.autoCloseTimer);
            this.autoCloseTimer = null;
        }
        if (this.portPromptFocusHandler) {
            window.removeEventListener('focus', this.portPromptFocusHandler);
            this.portPromptFocusHandler = null;
        }
    }
    appendProgressText(message) {
        this.setState(state => ({
            progressText: state.progressText + message,
            progressLines: state.progressLines.concat(splitProgressLines(message))
        }));
    }
    replaceProgressText(message) {
        this.setState({
            progressText: message,
            progressLines: splitProgressLines(message)
        });
    }
    isElectron() {
        // Renderer process
        if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
            return true;
        }

        // Main process
        if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
            return true;
        }

        // Detect the user agent when the `nodeIntegration` option is set to true
        return typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0;


    }
    fetchSerialPorts(callback) {
        const strings = getUploadStrings(this.props.intl.locale);
        axios.get(`${localUrl}/getports`)
            .then((response) => {
                if (response.data.success && response.data.ports.length > 0) {
                    this.setState({
                        isOpen: false,
                        serialList: response.data.ports,
                        portSelectModalOpen: true,
                        uploadPhase: 'selectPort',
                        progressText: strings.portsFound(response.data.ports.length),
                        progressLines: splitProgressLines(strings.portsFound(response.data.ports.length))
                    });
                } else {
                    this.setState({
                        uploadPhase: 'error',
                        progressText: strings.noPortsFound,
                        progressLines: splitProgressLines(strings.noPortsFound),
                        portSelectModalOpen: false,
                        isOpen: true,
                    });
                }
                callback()
            })
            .catch((error) => {
                console.error('Error fetching serial ports:', error);
                this.setUploadPhase('error');
                this.replaceProgressText(getPortListErrorMessage(error, strings));
            });
    }

    async codeGenerate(type = undefined) {
        const strings = getUploadStrings(this.props.intl.locale);
        const uploadPort = this.state.selectedPort && this.state.selectedPort.path;

        if (this.props.servoLiveEnabled) {
            this.setState({
                isOpen: true,
                portSelectModalOpen: false,
                uploadPhase: 'error',
                progressText: strings.disableServoLiveBeforeUpload,
                progressLines: splitProgressLines(strings.disableServoLiveBeforeUpload)
            });
            return;
        }

        if (this.isElectron() && !uploadPort) {
            this.setState({
                isOpen: false,
                portSelectModalOpen: true,
                uploadPhase: 'selectPort',
                progressText: strings.portsFound(this.state.serialList.length || 0),
                progressLines: splitProgressLines(strings.portsFound(this.state.serialList.length || 0))
            });
            this.fetchSerialPorts(() => {
            });
            return;
        }

        this.setState({
            isOpen: this.state.currentOs !== 'Android',
            progressText: strings.serverSending,
            progressLines: splitProgressLines(strings.serverSending),
            uploadPhase: 'sending'
        });
        const reduxGeneratedCode = this.props.changeMonskitGeneratedCodes;
        const liveWorkspaceCode = getLiveWorkspaceCode();
        console.log('upload code snapshot', {
            same: reduxGeneratedCode === liveWorkspaceCode,
            reduxLength: reduxGeneratedCode ? reduxGeneratedCode.length : 0,
            liveLength: liveWorkspaceCode ? liveWorkspaceCode.length : 0,
            reduxGeneratedCode,
            liveWorkspaceCode
        });
        const sendData = {
            code: reduxGeneratedCode
        };
        const sampleColde2 = `
                #include <Arduino.h>
                #include <XROBO.h>
                #define RF_lite 1

                void _loop() {
                }

                void setup() {
                  Start(3);
                  while (1) {
                    rf_send(20, 20, 500);
                    motor(20, 20, 500);
                    delay(1000);
                    motor(-5, -5, 500);
                    delay(1000);


                  }
                }

                void loop() {
                  tm2();
                }
`;

        // sendData.code = sampleColde2;
        const config = {
            timeout: 300000
        };
        if (this.isElectron()) { // 일렉트론 모드인 경우 로컬 업로더로 전송
            const url = `${localUrl}/upload`;
            sendData.port = uploadPort;
            this.setUploadPhase('compiling');
            this.replaceProgressText(strings.selectedPortCompiling(sendData.port));

            axios.post(url, sendData, config)
                .then(result => {
                    console.log(result.data);
                    if (!result.data.success) { // 컴파일 에러
                        this.setUploadPhase('error');
                        this.appendProgressText(getCompileErrorMessage(result.data?.stderr || result.data?.error, strings));
                    } else {
                        this.setUploadPhase('complete');
                        this.setState(state => ({
                            progressText: state.progressText + strings.uploadCompletedInline,
                            progressLines: state.progressLines.concat(splitProgressLines(strings.uploadCompletedInline)),
                            progressTextAfterSelectPort: ``,
                            selectedPort:undefined
                        }));

                    }
                });

        } else if (this.state.currentOs === 'Mac OS') {
        const url = `${baseUrl}/test`;
        axios.post(url, sendData, config)
            .then(result => {
                console.log(result.data);
                if (result.data?.type === 'CE' || result.data?.type === 'SE') {
                    this.setUploadPhase('error');
                    this.appendProgressText(getPrepareResponseErrorMessage(result.data, strings));
                } else {
                    this.setUploadPhase('selectPort');
                    this.replaceProgressText(strings.fileReceived + strings.selectSerialForUpload);
                    const myBlob = [new Blob([result.data])];
                    const file = new File(myBlob, 'compiled.hex');
                    this.handleSubmit(file);
                }
            })
            .catch(error => {
                console.error('Error preparing upload:', error);
                this.setUploadPhase('error');
                this.appendProgressText(getServerRequestErrorMessage(error, strings));
            });


        } else if (this.state.currentOs === 'Android' && type !== 'Android upload confirm') { // android device
            if (window.AndroidInterface && typeof window.AndroidInterface.checkConnectionAndShowAlert === 'function') {
                // 연결 상태와 업로드 여부 확인
                const canProceed = window.AndroidInterface.checkConnectionAndShowAlert();
                console.log(canProceed)
                if (!canProceed) {
                    console.log('업로드 취소됨 또는 연결 상태 OFF');
                    this.setUploadPhase('error');
                    this.appendProgressText(strings.uploadCancelled);
                    return;
                }
            } else {
                console.error('AndroidInterface.checkConnectionAndShowAlert is not available');
                this.setUploadPhase('error');
                this.appendProgressText(strings.filePrepareError);
                return;
            }

        } else if (type === 'Android upload confirm') {
            this.uploadToAndroid(sendData, config);
        } else { // windows mode (윈도우 크롬 브라우저)
            const url = `${baseUrl}/test`;
            axios.post(url, sendData, config)
                .then(result => {
                    console.log(result.data);
                    if (result.data?.type === 'CE' || result.data?.type === 'SE') {
                        this.setUploadPhase('error');
                        this.appendProgressText(getPrepareResponseErrorMessage(result.data, strings));
                    } else {
                        this.setUploadPhase('selectPort');
                        this.replaceProgressText(strings.fileReceived + strings.selectSerialForUpload);
                        const myBlob = [new Blob([result.data])];
                        const file = new File(myBlob, 'compiled.hex');
                        this.handleSubmit(file);
                    }
                })
                .catch(error => {
                    console.error('Error preparing upload:', error);
                    this.setUploadPhase('error');
                    this.appendProgressText(getServerRequestErrorMessage(error, strings));
                });

            // axios.post(baseUrl + '/save_wait', sendData, config)
            //     .then(result => {
            //         if (result.data === 'CE') { //컴파일 에러
            //             this.setState((state) => ({progressText: state.progressText + CompileError}));
            //         } else if (result.data === 'SE') {
            //             this.setState((state) => ({progressText: state.progressText + ServerError}));
            //         } else {
            //             let key = result.data + '.ino.hex';
            //             this.setState((state) => ({
            //                 progressText: state.progressText + progress2 + readingSerial
            //             }));
            //             this.setState({
            //                 ...this.state,
            //                 key: key
            //             });
            //             if (socket.readyState === 1) {
            //                 socket.send('list');
            //                 socket.onmessage = e => {
            //                     console.log(event.data)
            //
            //                     let serialList = JSON.parse(event.data).SerialPorts;
            //                     if (serialList) {
            //                         this.setState({
            //                             ...this.state,
            //                             selectable: true,
            //                             serialList: serialList,
            //                             progressText: this.state.progressText + progress3
            //                         });
            //                     }
            //                 };
            //             } else {
            //                 socket = new WebSocket('ws://localhost:8989/ws');
            //                 socket.onopen = e => {
            //                     socket.send('list');
            //                     socket.onmessage = (event) => {
            //
            //                         let serialList = JSON.parse(event.data).SerialPorts;
            //                         if (serialList) {
            //                             this.setState({
            //                                 ...this.state,
            //                                 selectable: true,
            //                                 serialList: serialList,
            //                                 progressText: this.state.progressText + progress3
            //                             });
            //                         }
            //                     };
            //                 };
            //             }
            //
            //
            //         }
            //     });

        }
    }

    async pauseServoLiveIfNeeded () {
      if (!this.props.servoLiveEnabled || !this.props.servoLivePortPath || !this.props.servoLiveConnected) {
          this.setState({
              wasServoLiveEnabledBeforeUpload: false,
              servoLiveReconnectPort: null
          });
          return;
      }

      this.setState({
          wasServoLiveEnabledBeforeUpload: true,
          servoLiveReconnectPort: this.props.servoLivePortPath
      });

      try {
          console.log('pausing servo live:', this.props.servoLivePortPath);
          await disconnectServoLive();
          await new Promise(resolve => setTimeout(resolve, 700));
          console.log('servo live disconnected before upload');
          this.props.onSetServoLiveConnected(false);
      } catch (error) {
          console.error('Failed to pause servo live before upload:', error);
      }
  }

  async resumeServoLiveIfNeeded () {
      const {wasServoLiveEnabledBeforeUpload, servoLiveReconnectPort} = this.state;

      if (!wasServoLiveEnabledBeforeUpload || !servoLiveReconnectPort) {
          return;
      }

      try {
          await new Promise(resolve => setTimeout(resolve, 1000));
          await connectServoLive(servoLiveReconnectPort);
          console.log('servo live reconnected after upload:', servoLiveReconnectPort);
          this.props.onSetServoLiveConnected(true);
      } catch (error) {
          console.error('Failed to resume servo live after upload:', error);
          this.props.onSetServoLiveConnected(false);
      }
  }

    uploadToAndroid(sendData, config) {
        const strings = getUploadStrings(this.props.intl.locale);
        const url = `${baseUrl}/test`;
        axios.post(url, sendData, config)
            .then(result => {
                if (result.data?.type === 'CE') { // 컴파일 에러
                    this.setUploadPhase('error');
                    this.appendProgressText(getCompileErrorMessage(result.data?.stderr, strings));
                } else if (result.data?.type === 'SE') {
                    this.setUploadPhase('error');
                    this.appendProgressText(getPrepareResponseErrorMessage(result.data, strings));
                } else {
                    this.setUploadPhase('uploading');
                    this.appendProgressText(strings.fileReceived + strings.uploading);
                    // Android 메서드 호출
                    const hexString = result.data;
                    if (window.AndroidInterface && typeof window.AndroidInterface.receiveHexFile === 'function') {
                        window.AndroidInterface.receiveHexFile(hexString); // hex 데이터 전달

                        console.log('Hex data sent to AndroidInterface');
                    } else {
                        console.error('AndroidInterface is not available or receiveHexFile method is missing');
                        this.setUploadPhase('error');
                        this.appendProgressText(strings.filePrepareError);
                    }
                }
            })
            .catch(error => {
                console.error('Error preparing upload:', error);
                this.setUploadPhase('error');
                this.appendProgressText(getServerRequestErrorMessage(error, strings));
            });
    }

    setPort(e, port) {
        const key = this.state.key;
        const compileServer = `${baseUrl}/send_delete/${key}`;
        const cmdLine = `programfromurl ${port} arduino:avr:uno ${compileServer}`;
        this.setState({
            ...this.state,
            selectable: false,
            cmdLine: cmdLine
        }, () => {
            socket.send(cmdLine);
            console.log(cmdLine);
            console.log(compileServer);

            socket.onmessage = msg => {
                console.log(msg);
                const strings = getUploadStrings(this.props.intl.locale);

                const msgJson = msg.data;
                if (msgJson.includes('programfromurl') && !this.state.progressText.includes(strings.uploading)) {
                    this.setUploadPhase('uploading');
                    this.appendProgressText(strings.uploading);
                } else if (msgJson.includes('Flash') && msgJson.includes('OK') && !this.state.progressText.includes(strings.uploadDone)) {
                    this.setUploadPhase('complete');
                    this.appendProgressText(strings.uploadDone);
                }

            };

        });
    }



    handleSubmit(file) {
        const strings = getUploadStrings(this.props.intl.locale);

        const _this = this;
        let filecontents;
        const reader = new FileReader();
        const board = 'nano (new bootloader)';
        // var board = {
        //     name: 'custom-nano',
        //     baud: 115200, // 보드의 기본 보드레이트
        //     signature:[0x1E, 0x95, 0x0F], // ATmega328P의 시그니처
        //     protocol: 'arduino', // 업로드 프로토콜
        //     manualReset: false
        // };

        reader.onload = function (event) {
            filecontents = event.target.result;

            const avrgirl = new AvrgirlArduino({
                board: board,
                debug: true
            });
            console.log(filecontents);
            console.log(avrgirl);
            _this.clearAutoCloseTimer();
            _this.portPromptFocusHandler = () => {
                window.removeEventListener('focus', _this.portPromptFocusHandler);
                _this.portPromptFocusHandler = null;
                _this.setUploadPhase('uploading');
            };
            window.addEventListener('focus', _this.portPromptFocusHandler, {once: true});
            avrgirl.flash(filecontents, error => {
                console.log('avrgirl flash error:', error);
                if (error) {
                    console.log('avrgirl flash error code:', error.code);
                    console.log('avrgirl flash error message:', error.message);
                }
                if (_this.portPromptFocusHandler) {
                    window.removeEventListener('focus', _this.portPromptFocusHandler);
                    _this.portPromptFocusHandler = null;
                }
                if (error) {
                    _this.setUploadPhase('error');
                    _this.appendProgressText(getWebUploadErrorMessage(error, strings));
                } else {
                    _this.setUploadPhase('complete');
                    _this.appendProgressText(strings.uploadDone);
                }
            });

        };
        reader.readAsArrayBuffer(file);
    }


    handleModal() {
        this.clearAutoCloseTimer();
        this.setState({
            isOpen: false,
            portSelectModalOpen: false,
            uploadPhase: 'sending'
        });
        window.uploadFinished = false;


    }

    onClickPort = (port) => {
        console.log(port)
        const strings = getUploadStrings(this.props.intl.locale);
        this.setState({
            selectedPort: port,
            progressTextAfterSelectPort: strings.selectedPortUploadSoon(port.path)
        })
        setTimeout(() => {
            this.setState({portSelectModalOpen: false, isOpen: true});
            this.codeGenerate();

        }, 2000)
    }


    render() {
        const strings = getUploadStrings(this.props.intl.locale);
        const isSelectPortState = this.state.portSelectModalOpen;
        const cardVisible = this.state.isOpen || isSelectPortState;
        const cardState = this.state.uploadPhase === 'error' ?
            'error' :
            isSelectPortState ?
                'selectPort' :
                this.state.uploadPhase;
        const status = getStatusConfig(this.props.intl.locale, cardState);
        const isErrorPhase = cardState === 'error';
        const errorCardLines = getErrorCardLines(this.state.progressLines, this.props.intl.locale);

        return (
            <div className={myStyle.uploadButton}>
                <div
                    onClick={this.codeGenerate}
                    className={myStyle.uploadButtonReal}
                >
                    <img src={uploadIcon} style={{width: '1.25rem', height: '1.25rem', marginRight: '0.3rem'}} />
                    {strings.buttonLabel}
                </div>
                {cardVisible ? (
                    <div className={modalStyle.overlay}>
                        <div className={classNames(
                            modalStyle.container,
                            isErrorPhase && modalStyle.containerError
                        )}>
                            <div className={modalStyle.header}>
                                <div className={modalStyle.headerAccent} />
                                <div className={modalStyle.headerText}>
                                    {strings.uploadToXrobo}
                                </div>
                                <button
                                    className={modalStyle.xBox}
                                    onClick={this.handleModal}
                                    type="button"
                                >
                                    <img
                                        src={xBox}
                                        className={modalStyle.xBoxIcon}
                                        alt="Close"
                                    />
                                </button>
                            </div>
                            <div className={modalStyle.content}>
                                <div className={modalStyle.contentContent}>
                                    <div className={modalStyle.statusSummary}>
                                        <div className={classNames(
                                            modalStyle.statusBadge,
                                            isErrorPhase && modalStyle.statusBadgeError
                                        )}>
                                            {status.label}
                                        </div>
                                        <div className={modalStyle.statusTitle}>{status.title}</div>
                                        <div className={classNames(
                                            modalStyle.statusDescription,
                                            isErrorPhase && modalStyle.statusDescriptionError
                                        )}>
                                            {isSelectPortState ? (
                                                this.props.intl.locale === 'ko' ?
                                                    '브라우저 상단에 표시된 창에서 연결할 포트를 선택해 주세요.' :
                                                    'Choose the port from the browser prompt shown near the top of the page.'
                                            ) : status.description}
                                        </div>
                                    </div>

                                    {isSelectPortState ? (
                                        <div className={modalStyle.portGuideCard}>
                                            <div className={modalStyle.portGuideTitle}>
                                                {this.props.intl.locale === 'ko' ?
                                                    '포트를 선택해 주세요' :
                                                    'Select a port'}
                                            </div>
                                            <div className={modalStyle.portGuideDescription}>
                                                {this.props.intl.locale === 'ko' ?
                                                    '브라우저 상단에 표시된 포트 선택 창에서 연결할 포트를 선택하면 업로드를 계속합니다.' :
                                                    'Choose the device from the browser port picker near the top of the page to continue.'}
                                            </div>
                                        </div>
                                    ) : null}

                                    {cardState === 'uploading' ? (
                                        <div className={modalStyle.progressArea}>
                                            <div className={modalStyle.progressRail}>
                                                <div className={modalStyle.progressFillIndeterminate} />
                                            </div>
                                            <div className={modalStyle.progressValue}>
                                                {this.props.intl.locale === 'ko' ? '업로드 중...' : 'Uploading...'}
                                            </div>
                                        </div>
                                    ) : null}

                                    {cardState === 'complete' ? (
                                        <div className={modalStyle.completionCard}>
                                            {this.props.intl.locale === 'ko' ?
                                                '업로드 완료' :
                                                'Upload complete'}
                                        </div>
                                    ) : null}

                                    {isErrorPhase ? (
                                        <div className={modalStyle.errorCard}>
                                            {errorCardLines.length > 0 ? errorCardLines.map((line, index) => (
                                                <div
                                                    key={`error-line-${index}`}
                                                    className={line.startsWith(this.props.intl.locale === 'ko' ? '상세:' : 'Detail:') ?
                                                        modalStyle.errorDetail :
                                                        undefined}
                                                >
                                                    {line}
                                                </div>
                                            )) : (
                                                this.props.intl.locale === 'ko' ?
                                                    '업로드를 완료하지 못했습니다.' :
                                                    'The upload could not be completed.'
                                            )}
                                        </div>
                                    ) : null}

                                    {isSelectPortState && this.state.serialList.length > 0 ? (
                                        <div className={modalStyle.serialWrapper}>
                                            {this.state.serialList.map((item, index) => (
                                                <div
                                                    key={`${item.path || 'port'}-${index}`}
                                                    className={classNames(modalStyle.serialOption, {
                                                        [modalStyle.selected]: this.state.selectedPort === item.path
                                                    })}
                                                    onClick={() => this.onClickPort(item)}
                                                >
                                                    <strong>{item.path}</strong>
                                                    <span>{item.manufacturer || strings.unknownManufacturer}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

}


const mapStateToProps = state => ({
    changeMonskitGeneratedCodes: state.scratchGui.MonskitGeneratedCodes,
    servoLiveEnabled: state.scratchGui.servoLive.enabled,
    servoLivePortPath: state.scratchGui.servoLive.portPath,
    servoLiveConnected: state.scratchGui.servoLive.connected
});

const mapDispatchToProps = dispatch => ({
    onchangeMonskitGeneratedCodes: codes => dispatch(changeMonskitGeneratedCodes(codes)),
    onSetServoLiveConnected: connected => dispatch(setServoLiveConnected(connected))

});


const ConnectedcodeSender = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(CodeSender));


export default ConnectedcodeSender;
